"use client";
import { useFollowValue } from './use-follow-value.mjs';

function useSpring(source, options = {}) {
    return useFollowValue(source, { type: "spring", ...options });
}

export { useSpring };
//# sourceMappingURL=use-spring.mjs.map
